var map = {
	"./chris150-allPrize.png": 95587,
	"./chris200-allPrize.png": 69254,
	"./coin10-allPrize.png": 17615,
	"./coin100-allPrize.png": 26998,
	"./coin15-allPrize.png": 52392,
	"./coin20-allPrize.png": 62807,
	"./coin30-allPrize.png": 62513,
	"./coin5-allPrize.png": 70957,
	"./coin50-allPrize.png": 68889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40384;